import { render, staticRenderFns } from "./CoTwoWasteForm.vue?vue&type=template&id=10d517a7&scoped=true&"
import script from "./CoTwoWasteForm.vue?vue&type=script&lang=js&"
export * from "./CoTwoWasteForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10d517a7",
  null
  
)

export default component.exports